import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";
import { useDeploymentLineLegalPublisher } from "@Front/Services/DeploymentLineLegalPublisher/DeploymentLineLegalPublisherContext";

import classes from "./classes.module.scss";
import { LegalNoticePublisher } from "./LegalNoticePublisher";
import { LegalNoticeLine } from "./LegalNoticePrimitives";

function LegalNoticeHeader(): React.JSX.Element {
	const { legalNotice } = useDeploymentLineLegalPublisher();
	return (
		<>
			<Typography typo={ETypo.TITLE_H4} color={ETypoColor.TEXT_PRIMARY}>
				Mentions légales
			</Typography>
			<Typography typo={ETypo.TEXT_LG_SEMIBOLD} color={ETypoColor.TEXT_SECONDARY} italic>
				Version en vigueur à compter du {legalNotice.effectiveFromLabel}
			</Typography>
			<LegalNoticeLine>{legalNotice.lcenIntro}</LegalNoticeLine>
		</>
	);
}

export default function LegalNotice(): React.JSX.Element {
	return (
		<div className={classes["root"]}>
			<section>
				<LegalNoticeHeader />
				<LegalNoticePublisher />
			</section>
		</div>
	);
}
